import React from 'react'
import "./Style/Style.css";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div>
      <section className="footer" id="footer">
            <div className="box-container">
                <div className="box">
                    <h3>Quick links</h3>
                    <Link to="/"> <i className="fas fa-arrow-right"></i> Home </Link>
                    <Link to="/about"> <i className="fas fa-arrow-right"></i> About </Link>
                    <Link to="/services"> <i className="fas fa-arrow-right"></i> Services </Link>
                    <Link to="/blog"> <i className="fas fa-arrow-right"></i> Blog </Link>
                    <Link to="/contact"> <i className="fas fa-arrow-right"></i> Appointment </Link>
                </div>
                <div className="box">
                    <h3>contact info</h3>
                    <Link to="/"><i className="fas fa-phone"></i> +91 9935352734 </Link>
                    <Link to="/"> <i className="fas fa-phone"></i> +91 8819021280 </Link>
                    <Link to="/"> <i className="fas fa-envelope"></i> margadarshaksathi@gmail.com </Link>
                    <Link to="/"> <i className="fas fa-map-marker-alt"></i> TamilNadu, Bharat - 400104 </Link>
                </div>
                <div className="box">
                    <h3>contact info</h3>
                    <Link to="/"> <i className="fab fa-facebook-f"></i> facebook </Link>
                    <Link to="https://www.youtube.com/@MargdarshakSathi"> <i className="fab fa-youtube"></i> youtube </Link>
                    <Link to="https://instagram.com/margdarshak_sathi?igshid=MzRlODBiNWFlZA=="> <i className="fab fa-instagram"></i> instagram </Link>
                    <Link to="/"> <i className="fab fa-linkedin"></i> linkedin </Link>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Footer
